import EgressHelper from '@livekit/egress-sdk';
import { Center, Text } from '@mantine/core';
import { RoomAudioRenderer, RoomContext } from '@livekit/components-react';
import { Room } from 'livekit-client';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router';

import { EgressComposite } from './egress-composite';
import classes from './egress-page.module.css';
import { waitForMedia } from './wait-for-media';
import { i18n, SUPPORTED_LANGUAGES } from '@/i18n';

export function EgressPage() {
    const [searchParams] = useSearchParams();
    const langParam = searchParams.get('lang');
    const language = SUPPORTED_LANGUAGES.find((supported) => supported === langParam) ?? 'ru';
    const [room] = useState(() => new Room());
    const [layout, setLayout] = useState(() => EgressHelper.getLayout());
    const [error, setError] = useState<string>();

    useEffect(() => {
        void i18n.changeLanguage(language);
    }, [language]);

    useEffect(() => {
        const abort = new AbortController();
        EgressHelper.onLayoutChanged(setLayout);
        EgressHelper.setRoom(room);
        const connect = async () => {
            await room.connect(EgressHelper.getLiveKitURL(), EgressHelper.getAccessToken());
            await waitForMedia(room, abort.signal);
            if (!abort.signal.aborted) EgressHelper.startRecording();
        };
        connect().catch((connectError: unknown) => {
            setError(connectError instanceof Error ? connectError.message : String(connectError));
        });
        return () => {
            abort.abort();
            void room.disconnect();
        };
    }, [room]);

    return (
        <main className={classes.viewport} data-lk-theme="default">
            {error ? (
                <Center h="100%">
                    <Text c="danger">{error}</Text>
                </Center>
            ) : (
                <RoomContext value={room}>
                    <EgressComposite layout={layout} />
                    <RoomAudioRenderer />
                </RoomContext>
            )}
        </main>
    );
}
